import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  logoBase64: PropTypes.string,
};

const defaultProps = {
  logoBase64: '',
};

class AdminTableBrand extends Component {
  render() {
    const { logoBase64, ...props } = this.props;

    const _getBackgroundImageStyle = () => (logoBase64 !== '' ? { backgroundImage: `url(data:image;base64,${logoBase64})` } : {});

    return (
      <div
        className="AdminTableBrand"
        style={_getBackgroundImageStyle()}
        {...props}
      />
    );
  }
}

AdminTableBrand.propTypes = propTypes;
AdminTableBrand.defaultProps = defaultProps;

export default AdminTableBrand;
